/**************************************************
 * Nombre:       Formulario_Lead_Contacto_Fecha.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {SchoolOutlined,HistoryEduOutlined} from "@mui/icons-material";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../Modulo_formularios/Componentes/IngresoHora";

const Formulario_Lead_Contacto_Fecha = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoFecha Icono={SchoolOutlined} nombre={'Fecha'} dato={'fecha'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoHora Icono={SchoolOutlined} nombre={'Hora'} dato={'hora'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={3} nombre={'Notas'} dato={'notas'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lead_Contacto_Fecha